var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-body"},[_c('div',{staticClass:"banner-content"},[_c('div',{staticClass:"header"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.bannerImg,"fit":"cover"}})],1),_c('div',{staticClass:"four-stage"},[_c('div',{staticClass:"four-stage-box"},_vm._l((_vm.fourStageChildTitle),function(item,index){return _c('router-link',{key:index,staticClass:"fs-title",class:{ bg: _vm.$route.path.indexOf(item.route) !== -1 },attrs:{"to":{
            path: item.route,
            query: {
              titleId: _vm.titleId,
              nodeId: item.titleId,
            },
          }}},[_c('div',{staticClass:"fs-title-chinese"},[_vm._v(_vm._s(item.name))])])}),1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }